const messages = {
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_FD.title': 'PRE / FD',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_FD.excerpt':
    'Pre-Money-Valuation / fully-diluted share capital',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_ND.title': 'PRE / ND',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_ND.excerpt':
    'Pre-Money-Valuation / non-diluted share capital',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_INC_CNS_FD.title': 'PRE / (FD+CNs)',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_INC_CNS_FD.excerpt':
    'Pre-Money-Valuation / fully diluted share capital inc. potential conversions',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_INC_CNS_ND.title': 'PRE / (ND+CNs)',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_INC_CNS_ND.excerpt':
    'Pre-Money-Valuation / share capital inc. potential conversions',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_AS_IF_FD.title': 'PRE-AS-IF / FD',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_AS_IF_FD.excerpt':
    'Pre-Money-as-if-converted / fully diluted share capital',
  'defaultPriceCalculationMethods.MANUAL_PRICE.title': 'MANUAL',
  'defaultPriceCalculationMethods.MANUAL_PRICE.excerpt':
    'No automatic calculation of the price in bulk edits',

  'conversionBulkTable.automaticCalculation.title':
    'Automatische Berechnung der diskontierten Preise',
  'conversionBulkTable.automaticCalculation.excerpt':
    'Wenn diese Option aktiviert ist, berechnen wir den diskontierten Preis und die Anzahl der Aktien für jede Wandlung automatisch auf der Grundlage der verschiedenen Parameter der Wandelanleihe. Die Preise der Wandelschuldverschreibungen werden auf der Grundlage der gewählten Berechnungsmethode und möglicher Abschläge/Vorabdeckungen ermittelt. Beachten Sie, dass alle Umwandlungen in der Tabelle aktualisiert werden, wenn dieses Kästchen aktiviert ist, einschließlich der bereits angepassten Aktiennummern.',

  'equityBulkTable.numberOfShares.title': 'Anzahl der Anteile basierend auf den Anteilspreisen.',
  'equityBulkTable.numberOfShares.excerpt':
    'Wenn diese Option aktiviert ist, berechnen wir die Anzahl der Anteile für jede Investition automatisch auf der Grundlage der verschiedenen Anteilspreise. Die Anteilspreise sind auf Grundlage der ausgewählten Berechnungsmethoden kalkuliert. Beachten Sie, dass alle Eigenkapital Investitionen in der Tabelle aktualisiert werden, wenn dieses Kontrollkästchen aktiviert ist, einschließlich bereits angepasster Investitionen.',

  'entity.CnInvestment.convertibleNote.forcedPaymentOnConversion.title': 'Nachzahlungsbetrag',
  'entity.CnInvestment.convertibleNote.forcedPaymentOnConversion.excerpt':
    'Bei der Wandlung muss jeder Investor einen festen Nachzahlungsbetrag pro share zahlen. Dies ist gängige Praxis, z.B. wird in Deutschland 1€ pro Aktie zusätzlich gezahlt.',

  'grantsOverview.exit.settings.accelerationOnExit.title': 'Vesting Aufholung im Exit-Fall',
  'grantsOverview.exit.settings.accelerationOnExit.excerpt':
    'Falls aktiviert, berechnen wir den aktuellen Optionspaket-Wert unter Berücksichtigung der Akzeleration-Option des Vestings für Mitarbeiteroptionen.',

  'grantsModelling.settings.form.csOptionValue.title':
    'Wert einer Stammaktienoptionen bei erwartetem Exit',
  'grantsModelling.settings.form.csOptionValue.excerpt':
    'Zeigt den erwarteten Exit-Erlös einer Stammaktienoptionen unter Berücksichtigung aller aktuellen Sonderrechte und der Gesellschafterstruktur.',

  'payoutStructure.help.default.title': 'Auszahlungsstruktur im Falle eines Exit-Ereignisses.',
  'payoutStructure.help.default.excerpt':
    'Anteilsklassen haben oft unterschiedliche Senioritätsstufen, die die Reihenfolge der Auszahlungen im Falle eines Exit-Ereignisses festlegen. Die Vorzugsbeträge für verschiedene Anteilsklassen werden z. B. durch die vereinbarten Liquidationspräferenzen definiert. Manchmal vereinbaren die Parteien jedoch zusätzliche Klauseln für die Auszahlungshöhe, um bestimmte Gruppen zu entschädigen. So ist z.B. ein Founder-Catch-Up ein gängiges Beispiel, um Gründern auch bei geringeren Exit-Ereignissen eine gewisse Entschädigung zu garantieren. Sie können diese zusätzlichen Klauseln hier hinzufügen, um die Exit-Verteilung in den Wasserfallberechnungen anzupassen.',

  'liquidationPreference.customSharePrice.default.title': 'Alternativer Aktienpreis',
  'liquidationPreference.customSharePrice.default.excerpt':
    'Falls angegeben, basiert der Nominalbetrag für die Berechnung der Vorzugsbeträge auf dem festen alternativen Aktienpreis, statt auf dem von den Investoren gezahlten Preis, der sich aus dem bereitgestellten Investitionsbetrag ergab.',
  'liquidationPreference.customSharePrice.default.link':
    'https://ventury-analytics.de/academy/wiki',

  'groupPage.members.tooltipOrga.title': 'Organisation',
  'groupPage.members.tooltipOrga.excerpt':
    'Dies ist die Übersichtsseite Ihrer Organisation. Hier können Sie Ihre Mitglieder verwalten und den Premium-Zugang für Ihre verschiedenen Projekte aktivieren.',
  'groupPage.packages.tooltipPackages.title': 'Pakete',
  'groupPage.packages.tooltipPackages.excerpt':
    'Im Bereich "Pakete" können Sie sehen, wie viele Pakete Sie bereits erworben haben.  Sie können auch überprüfen, wie viele Kontingente in einem Paket noch verfügbar sind, wann sie ablaufen und für welche Projekte einige davon bereits verwendet wurden.',
  'groupPage.packages.tooltipProjects.title': 'Projekte',
  'groupPage.packages.tooltipProjects.excerpt':
    'Dies ist die Übersicht über alle Projekte, die zur Organisation gehören. Durch Klicken auf "Beitreten" können Sie beliebig vielen Projekten beitreten. Hier können Sie auch Ihre Kontingente verwenden, um Projekte in Premium-Projekte zu verwandeln. Bitte beachten Sie, dass ein Kontingent unwiederbringlich verbraucht ist.',

  'generalInformation.guidedTour.title': 'Allgemeine Informationen darüber, wo was zu finden ist.',
  'generalInformation.guidedTour.excerpt':
    "Termsheet: Contains the most important points, which are later incorporated into the participation & shareholder agreement.Investment Angreement: Pre- & post-money valuation, Conversion of loans, Milestones / valuation adjustments, dilution protection, Shareholders' Agreement: liquidation preferences, Drag and Tag Along, Vesting, ESOP / Option Plans, Right of first Refusal",
  'generalInformation.guidedTour.link': null,
  'generalInformation.modelling.title': 'Wie man die Modellierung verwendet',
  'generalInformation.modelling.excerpt': null,
  'generalInformation.modelling.link': null,
  'generalInformation.roundingModes.title': 'Rundungsregeln für die Anteile',
  'generalInformation.roundingModes.excerpt':
    'Definieren Sie die Rundungsregeln für ausgegebene Anteile. Setzen Sie z.B. immer eine Untergrenze für die Investition/Preis, um die Anzahl der Aktien zu bestimmen.',
  'generalInformation.roundingModes.link': null,
  'generalInformation.default.title': null,
  'generalInformation.default.excerpt': null,
  'generalInformation.default.link': null,
  'capTable.default.title': 'Cap Table',
  'capTable.default.excerpt':
    'Ein Blick auf die Gesellschafterstruktur des Unternehmens. Er enthält eine detaillierte Beschreibung aller Eigentümer von Anteilen eines Unternehmens.',
  'capTable.default.link': null,
  'companyName.guidedTour.title': 'Unternehmensname',
  'companyName.guidedTour.excerpt':
    'Der Name des Unternehmens, für das Sie das Profil erstellen möchten.',
  'companyName.guidedTour.link': null,
  'companyName.default.title': null,
  'companyName.default.excerpt': null,
  'companyName.default.link': null,
  'exitOverview.dateInput.title': 'Exit-Datum',
  'exitOverview.dateInput.excerpt':
    'Das mögliche Datum für einen Exit. Es ist wichtig, da die Vesting-Pläne und die Dividenden für Wandeldarlehen, Kredite und Vorzugsbeträge auf der Grundlage dieses Datums berechnet werden.',
  'exitOverview.dateInput.link': null,
  'equityHolding.default.title': 'Eigenkapitalbeteiligung',
  'equityHolding.default.excerpt':
    'Vollständig verwässert, d.h. unter Berücksichtigung aller im Rahmen des (V)ESOP zuteilbaren VESOP-Aktien. Entspricht NICHT den Erlösen der Wasserfallanalyse aufgrund von Liq.Pref.',
  'equityHolding.default.link': null,
  'securities.slider.title': 'Informationen zum Schieberegler',
  'securities.slider.excerpt':
    'Der Schieberegler hilft Ihnen, die detaillierten Anteilsverteilungen unter Berücksichtigung der Einbeziehung verschiedener Ebenen virtueller Anteile anzuzeigen.',
  'securities.slider.link': null,
  'securities.shares.title': 'Anteile',
  'securities.shares.excerpt':
    'Die rechtlich relevante Verteilung der Anteile. Unter Ausschluss virtuell gewährter Anteile, geschaffener ESOP-Pools oder Vesting.',
  'securities.shares.link': null,
  'securities.vested.title': 'Einschließlich gevesteter Anteile',
  'securities.vested.excerpt':
    'Es wird eine Verteilung der gevesteten Anteile angezeigt, die nur die gevesteten Anteile (auf heutiger Basis) einschließt, ohne virtuelle Anteile (z.B. gewährte Anteile oder ESOP-Pools).',
  'securities.vested.link': null,
  'securities.esop.title': 'Einschließlich ESOP',
  'securities.esop.excerpt':
    'Es wird die virtuelle Anteilsverteilung gezeigt, einschließlich Grants und ESOPs (mit Abzug der virtuell getragenen Anteile der Geldgebern). Dies ist die vollständig verwässerte Basis.',
  'securities.esop.link': null,
  'securities.exit.title': 'Zu einem Exit-Ereignis',
  'securities.exit.excerpt':
    'Die virtuelle Anteilsverteilung wird so dargestellt, als ob ein Exit stattfindet. Sie umfasst eine Aufholung beim Vesting im Exit-Fall und die Rückgabe nicht gewährter Optionen an potenzielle ESOP-Geber.',
  'securities.exit.link': null,
  'guided.esop.title': 'Aktienbeteiligungspläne für Mitarbeiter (ESOP)',
  'guided.esop.excerpt':
    'Fügen Sie einen ESOP hinzu. Sie haben die Möglichkeit, Anteilsgewährungen und Vesting später über das ESOP-Menü hinzuzufügen.',
  'guided.esop.link': null,
  'waterfall.diagram.title': 'Wasserfall-Diagramm',
  'waterfall.diagram.excerpt':
    'Das Wasserfalldiagramm zeigt die Exit-Erlöse für verschiedene Exit-Bewertungen. Die Präferenzbeträge einschließlich der Dividenden werden auf der Grundlage des Exit-Datums berechnet.',
  'waterfall.diagram.link': null,
  'waterfall.capPoint.title': 'Cap Punkt',
  'waterfall.capPoint.excerpt':
    'Bei diesem Exit-Betrag wird der Anteil gedeckelt. Der effektive Cap-Punkt kann jedoch aufgrund von Wandlungen auf der Grundlage des Exit-Betrags früher liegen. Den effektiven Kappungspunkt finden Sie in der Exit-spezifischen Tabelle.',
  'waterfall.capPoint.link': null,
  'waterfall.conversionPoint.title': 'Wandlungspunkt',
  'waterfall.conversionPoint.excerpt':
    'Bei diesem Exit-Betrag wird der Anteil in Stammanteile umgewandelt, da eine anteilige Beteiligung für die Gesellschafter wirtschaftlich vorteilhafter ist.',
  'waterfall.conversionPoint.link': null,
  'companyInfo.existFounded.title': 'EXIST',
  'companyInfo.existFounded.excerpt': 'EXIST ist ein Förderprogramm der deutschen Regierung.',
  'companyInfo.existFounded.link': 'https://www.exist.de/EN/Programme/About-EXIST/content.html',
  'companyInfo.investGrant.title': 'INVEST',
  'companyInfo.investGrant.excerpt': 'INVEST ist ein Förderprogramm der deutschen Regierung.',
  'companyInfo.investGrant.link': 'https://www.exist.de/EN/Network/Partners/Invest/inhalt.html',
  'companyInfo.default.title': null,
  'companyInfo.default.excerpt': null,
  'companyInfo.default.link': null,
  'portfolio.exitReturns.title': 'Exit Erlöse',
  'portfolio.exitReturns.excerpt':
    'Die Exit-Renditen der einzelnen Projekte werden auf der Grundlage eines potenziellen Exits bei der Post-Money-Bewertung des Unternehmens berechnet. Die Erträge basieren auf Ihrer Position (Standardinvestor) im Unternehmen.',
  'portfolio.exitReturns.link': null,
  'shareInfo.guidedTour.title': 'Anteilsklasse dieser Runde',
  'shareInfo.guidedTour.excerpt':
    'Es gibt verschiedene Arten von Anteilen innerhalb eines Unternehmens. Am häufigsten finden sich Stammaktien oder Vorzugsaktien.',
  'shareInfo.guidedTour.link': 'https://ventury-analytics.de/academy/wiki',
  'shareInfo.default.title': null,
  'shareInfo.default.excerpt': null,
  'shareInfo.default.link': null,
  'antiDilution.default.title': 'Anti Dilution Regelung',
  'antiDilution.default.excerpt':
    'Ein Terminus, der einen Preisschutz für Investoren für den Fall bietet, dass ein Unternehmen eine Finanzierungsrunde zu einer niedrigeren Bewertung als eine vorherige Finanzierungsrunde abschließt.',
  'antiDilution.default.link': 'https://ventury-analytics.de/academy/wiki',
  'fullRatchet.default.title': 'Full Ratchet',
  'fullRatchet.default.excerpt':
    'Diese Spezifizierung der Anti Dilution Klausel ermöglicht es dem Anleger, sich in eine Position zu versetzen, als hätte er zum Preis der Downround investiert.',
  'fullRatchet.default.link': null,
  'broadBased.default.title': 'Broad Based',
  'broadBased.default.excerpt':
    'Der Nenner in den gewichteten durchschnittlichen Anti Dilution Berechnung, der auf einer vollständig verwässerten Betrachtung eines Unternehmens basiert. Das Gegenteil wird als narrow-based bezeichnet.',
  'broadBased.default.link': null,
  'narrowBased.default.title': 'Narrow Based',
  'narrowBased.default.excerpt':
    'Der Nenner bei den Berechnungen der gewichteten Anti Dilution Regelung auf allen Vorzugsanteilen basiert. Das Gegenteil wird als broad-based bezeichnet.',
  'narrowBased.default.link': null,
  'compensation.default.title': 'Kompensation',
  'compensation.default.excerpt':
    'Wählen Sie die Anteile aus, die der Anleger als Entschädigung erhält, falls die Anti Dilution Regel ausgelöst wird.',
  'compensation.default.link': null,
  'duration.default.title': 'Laufzeit',
  'duration.default.excerpt':
    'Die Laufzeit bestimmt, wie lange eine Anti Dilution Klausel für den Investor gültig ist. Falls ein Anteil mehrfach gekauft wurde, wird die Dauer immer auf der Grundlage der letzten Investition berechnet.',
  'duration.default.link': null,
  'transferType.default.title': 'Art der Kompensation',
  'transferType.default.excerpt':
    'Normalerweise erhält der Investor seine neuen Anteile über eine Ausgleichskapitalerhöhung zum Nominalwert. Es ist jedoch auch möglich, Anteile auf Kosten anderer Stammgesellschafter zu übertragen.',
  'transferType.default.link': null,
  'liquidationPreference.default.title': 'Liquidationspräferenz',
  'liquidationPreference.default.excerpt':
    'Durch diese Klausel erhalten die Investoren ihre Investition aus dem Erlös der Liquidation/des Verkaufs der Gesellschaft bevorzugt vor anderen. Bitte spezifizieren Sie diese Klausel mit den folgenden Details.',
  'liquidationPreference.default.link': 'https://ventury-analytics.de/academy/wiki',
  'simpleLiquidationPreference.default.title': 'Anrechenbare Liquidationspräferenz (SLP)',
  'simpleLiquidationPreference.default.excerpt':
    'Im Falle einer einfachen oder anrechenbaren Liquidationspräferenz erhält der Investor seinen investierten Betrag zurück, einschließlich eines möglichen Vielfachen oder einer Dividende. Eine Beteiligung am Resterlös ist nicht vorgesehen.',
  'simpleLiquidationPreference.default.link': 'https://ventury-analytics.de/academy/wiki',
  'participatingLiquidationPreference.default.title':
    'Nicht-anrechenbare Liquidationspräferenz (PLP)',
  'participatingLiquidationPreference.default.excerpt':
    'Mit der nicht-anrechenbaren Liquidationspräferenz erhält der Investor seine Investition einschließlich eines möglichen Vielfachen sowie Dividenden zurück und partizipiert an den Resterlösen auf der Grundlage seiner Anteilsquote',
  'participatingLiquidationPreference.default.link': 'https://ventury-analytics.de/academy/wiki',
  'interestRate.default.title': 'Zinsen oder Dividenden',
  'interestRate.default.excerpt':
    'Möglicherweise möchten Investoren zusätzlich zu ihrer Investition einen kumulierten Zins oder eine Dividende p.a. erhalten.',
  'interestRate.default.link': 'https://ventury-analytics.de/academy/wiki',
  'multiple.default.title': 'Multiple',
  'multiple.default.excerpt':
    'Investoren möchten vielleicht das x-fache ihrer Investition zurückerhalten, bevor andere den Erlös aus der Liquidation/dem Verkauf erhalten.',
  'multiple.default.link': 'https://ventury-analytics.de/academy/wiki',
  'senior.default.title': 'Seniorität',
  'senior.default.excerpt':
    'Normalerweise werden die Liquidationspräferenzen der letzten Investitionen zuerst bedient. Last In - First Out',
  'senior.default.link': 'https://ventury-analytics.de/academy/wiki',
  'remainingProceeds.default.title': 'Resterlös',
  'remainingProceeds.default.excerpt':
    'Bitte wählen Sie aus, wie der verbleibende Erlös an die Anteilseigner verteilt werden soll. Pro-rata: Der verbleibende Erlös wird auf der Grundlage der Beteiligungsquote der einzelnen Gesellschafter verteilt.',
  'remainingProceeds.default.link': 'https://ventury-analytics.de/academy/wiki',
  'voluntaryConversion.default.title': 'Wandlung',
  'voluntaryConversion.default.excerpt':
    'Ein Prozess, bei dem Vorzugsanteile in Stammanteile umgewandelt werden. Wird hauptsächlich dann angewandt, wenn die Liquidationspräferenzen nicht partizipieren oder gedeckelt sind.',
  'voluntaryConversion.default.link': null,
  'pricePerShare.guidedTour.title': 'Preis pro Anteil',
  'pricePerShare.guidedTour.excerpt':
    'Der Preis pro Anteil ist die As-If-Converted Pre-Money-Bewertung geteilt durch die Summe aller vorherigen Anteile.',
  'pricePerShare.guidedTour.link': null,
  'pricePerShare.default.title': null,
  'pricePerShare.default.excerpt': null,
  'pricePerShare.default.link': null,
  'numberOfShares.guidedTour.title': 'Anzahl der Anteile',
  'numberOfShares.guidedTour.excerpt':
    'Die Anzahl der Anteile wird berechnet, indem der Investitionsbetrag durch den gezahlten Preis pro Anteil geteilt wird.',
  'numberOfShares.guidedTour.link': null,
  'numberOfShares.default.title': null,
  'numberOfShares.default.excerpt': null,
  'numberOfShares.default.link': null,
  'discount.guidedTour.title': 'Discount',
  'discount.guidedTour.excerpt':
    'Dem Investor wird ein Discount auf den Aktienpreis in der Wandlungsrunde eingeräumt.',
  'discount.guidedTour.link': null,
  'discount.default.title': null,
  'discount.default.excerpt': null,
  'discount.default.link': null,
  'maturityDate.guidedTour.title': 'Fälligkeitsdatum',
  'maturityDate.guidedTour.excerpt':
    'Das Fälligkeitsdatum ist das Datum, an dem der Kapitalbetrag einer Anleihe, einer Entnahme oder eines anderen Schuldtitels fällig wird und an den Investor zurückgezahlt wird. Es kann auch eine Zwangswandlung auslösen.',
  'maturityDate.guidedTour.link': null,
  'maturityDate.default.title': null,
  'maturityDate.default.excerpt': null,
  'maturityDate.default.link': null,
  'preMoneyCap.guidedTour.title': 'Pre-Money-Cap',
  'preMoneyCap.guidedTour.excerpt':
    'Die Pre-Money-Cap ist die maximale Bewertung, auf deren Grundlage der Wandlungspreis für das Wandeldarlehen berechnet wird.',
  'preMoneyCap.guidedTour.link': null,
  'preMoneyCap.default.title': null,
  'preMoneyCap.default.excerpt': null,
  'preMoneyCap.default.link': null,
  'cummulative.guidedTour.title': 'Kumulierend',
  'cummulative.guidedTour.excerpt':
    'Verpflichtung zur Dividendennachzahlung auf Vorzugsaktien, wenn aufgrund schlechter Ertragslage eine Dividendenzahlung ausfällt.',
  'cummulative.guidedTour.link': null,
  'cummulative.default.title': null,
  'cummulative.default.excerpt': null,
  'cummulative.default.link': null,
  'preMoneyValuation.default.title': 'Pre-Money-Bewertung',
  'preMoneyValuation.default.excerpt':
    'Die Pre-Money-Bewertung ist die Post-Money-Bewertung abzüglich der Neuinvestition. Die Pre-Money-Bewertung und auch der Preis pro Anteil können auch auf einer vollständig verwässerten und As-if-Converted Basis berechnet werden.',
  'preMoneyValuation.default.link': 'https://ventury-analytics.de/academy/wiki',
  'upRound.simulation.title': 'Up-Round',
  'upRound.simulation.excerpt':
    'Eine Finanzierungsrunde, die zu einer höheren Bewertung durchgeführt wurde als die vorherige Runde.',
  'upRound.default.title': null,
  'upRound.default.excerpt': null,
  'upRound.default.link': null,
  'flatRound.simulation.title': 'Flat-Round',
  'flatRound.simulation.excerpt':
    'Eine Finanzierungsrunde, die mit der gleichen Post-Money-Bewertung durchgeführt wurde wie die vorhergehende Runde.',
  'flatRound.simulation.link': null,
  'flatRound.default.title': null,
  'flatRound.default.excerpt': null,
  'flatRound.default.link': null,
  'downRound.simulation.title': 'Down-Round',
  'downRound.simulation.excerpt':
    'Eine Finanzierungsrunde, die zu einer niedrigeren Post-Money-Bewertung als in der vorherigen Runde durchgeführt wurde.',
  'downRound.simulation.link': null,
  'downRound.default.title': null,
  'downRound.default.excerpt': null,
  'downRound.default.link': null,
}

export default messages
